import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import "./Cart.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { addtoCart } from "../redux/actions/cartAction";
import CartItem from "./CartItem";

const Cart = () => {
  const [checkbox, setCheckbox] = useState({
    isChecked: false,
  });
  const { productId } = useParams();
  const dispatch = useDispatch();
  const cartItem = useSelector((state) => state.cart);
  const { cartItems } = cartItem;




  useEffect(() => {
    if (productId) {
      dispatch(addtoCart(productId));
    }
  }, [dispatch, productId]);

  //Total Price calculation
  const itemPrice = cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);
  const shippingPrice = Number(50)
  const totalPrice = itemPrice + shippingPrice;

  console.log('cart data', cartItems);
  //Increment & Dcrement functionality 
  // const handleIncrement = (id) => {
  //   console.log('cart ', cartItems.product);
  // if(id === cartItems.product){
  //   cartItems.qty+1;
  // }
  // else{
  //   cartItems.qty;
  // }

  // setCart(cart => (
  // cartItems.map((item) => console.log(item))

  // ))

  // }
  //id===item.product ? {...item,qty:item.qty-1}:item
  const handleIncrement = (id) => {
    console.log('increment check', id)

    cartItems.map((item) =>
      // console.log('increment data', item))
        id === item.product ?{qty:item.qty+1} :  (console.log('false')) )
  
  }


  return (
    <div className="cart-container">
      <Header />
      <SubHeader title="Cart" text="Cart" width="container" />

      <div className="cart-container py-5">
        <div className="container ">
          <div className="row">
            <div className="col-lg-8">
              <table className="Wishlist_table table table-borderless text-white">
                <tbody>
                  <tr className="btm_border_dash">
                    {cartItems.map((item) => (
                      <CartItem
                        key={item.product}
                        item={item}
                        handleIncrement={handleIncrement}

                      />
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-lg-4">
              <div className="left-container">
                <div className="p-4">
                  <h4 className="mb-5 bold">Summury</h4>
                  <div className="calculation btm_border_dash">
                    <div className="d-flex justify-content-between">
                      <p>Order Total</p>
                      <p>
                        $
                        {itemPrice}
                      </p>
                    </div>
                    {checkbox.isChecked ? (
                      <input
                        className="form-control form-control-lg mb-4"
                        type="text"
                        placeholder="Type Code here"
                        aria-label=".form-control-lg example"
                      />
                    ) : (
                      <div className="d-flex justify-content-between">
                        <p>Apply promo code</p>
                        <div className="form-check form-switch">
                          <input
                            onClick={() => setCheckbox({ isChecked: true })}
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </div>
                    )}
                    <div className="d-flex justify-content-between">
                      <p>Promo Code</p>
                      <p className="bg_lightDark px-3 py-1 rounded-3 cl-pm">
                        ART31
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Shipping</p>
                      <p>$50.00</p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mt-3">
                    <p>Subtotal</p>
                    <p>$ {totalPrice}</p>
                  </div>
                  <Link to="/checkout">
                    <button type="submit" class="fixed_btn border1 w-100 my-3">
                      Proceed to Checkout
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
export default Cart;
